export const onHandRetailers = ['BestBuy'];
export const PDPlus_Choice_SubGroup_FAN_Discount_Name  = "FANDiscount"
export const PROVIDER_LOGO_MAP: Record<string, string> = {
    'at&t': 'pi pi-att',
    'att': 'pi pi-att',
    'charter': 'pi pi-charter',
    'spectrum': 'pi pi-charter', // Charter/Spectrum share the same icon
    'brightspeed': 'pi pi-brightspeed',
    'optimum': 'pi pi-optimum',
    'frontier': 'pi pi-frontier',
};